// src/app/core/services/storage.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }

  static readonly ACCESS_TOKEN = 'ACCESS_TOKEN';
  static readonly REFRESH_TOKEN = 'REFRESH_TOKEN';
  static readonly CURRENT_USER = 'CURRENT_USER';
}
